import { Button, InputBase } from "@mui/material";
import { createUseStyles } from "$utils/createUseStyles";
import EntrepotQtyBadge from "./EntrepotQtyBadge";
import { theme } from "$utils/theme/bataillog";

type Props = {
  entrepot: { _id: string; name: string };
  handleChangeQtyAskedEntrepot: (
    value: any,
    keyEntrepot: string,
    index: number
  ) => void;
  index: number;
  product: {
    warehouse: string;
    qtyAsked: number;
  };
  disabled?: boolean;
};

function EntrepotCell({
  entrepot,
  handleChangeQtyAskedEntrepot,
  index,
  product,
  disabled = false,
}: Props) {
  const classes = useStyles();
  const { name: keyEntrepot, _id } = entrepot;

  // If the product is from a reception, it's stored in one precise warehouse.
  const isFromAWarehouse = !!product.warehouse;
  const isStoredInThisWarehouse = product.warehouse === _id;

  const qtyAvalaible = product[keyEntrepot]?.qtyAvalaible;
  const qtyAvalaibleInitial = product[keyEntrepot]?.qtyAvalaibleInitial;

  return (
    <div className={classes.stockData}>
      <div className={classes.stockBadge}>
        <EntrepotQtyBadge availableQty={qtyAvalaible} qty={product?.qtyAsked} />
        <div className={classes.stockDataRight}>
          <div className={classes.stockInput}>
            <InputBase
              disabled={
                disabled || (isFromAWarehouse && !isStoredInThisWarehouse)
              }
              type="number"
              inputProps={{
                min: "0",
                step: "1",
                max:
                  isFromAWarehouse && isStoredInThisWarehouse
                    ? qtyAvalaibleInitial
                    : undefined,
                style: {
                  textAlign: "center",
                  background: "#fff",
                  height: 10,
                  border: "1px solid #eee",
                  borderRadius: 5,
                  maxWidth: 100,
                  fontSize: 14,
                },
              }}
              onChange={(e: any) => {
                handleChangeQtyAskedEntrepot(
                  e.target.value,
                  keyEntrepot,
                  index
                );
              }}
              style={{ width: "100%" }}
              value={product[keyEntrepot]?.qtyAsked}
            />
          </div>

          <Button
            disabled={
              disabled || (isFromAWarehouse && !isStoredInThisWarehouse)
            }
            variant="outlined"
            onClick={() =>
              handleChangeQtyAskedEntrepot(
                product?.qtyAsked,
                keyEntrepot,
                index
              )
            }
            style={{
              pointerEvents: "auto", // fix cursor to "default" when hovering the disabled button
              marginLeft: 8,
              minWidth: 24,
              height: 24,
              padding: 0,
              fontSize: 20,
            }}
            sx={{
              backgroundColor: "transparent !important",
              border: "1px solid rgba(0, 0, 0, 0.23) !important",
              color: "black !important",
              "&:not(.Mui-disabled):hover": {
                backgroundColor: `${theme.color.gray2} !important`,
              },
              "&:not(.Mui-disabled):focus": {
                backgroundColor: `${theme.color.gray1} !important`,
              },
              "&.Mui-disabled": {
                borderColor: "rgba(0, 0, 0, 0.12) !important",
                color: "rgba(0, 0, 0, 0.26) !important",
                cursor: "not-allowed !important",
              },
            }}
          >
            =
          </Button>
        </div>
      </div>
    </div>
  );
}

export default EntrepotCell;

const useStyles = createUseStyles(() => ({
  stockData: {
    display: "flex",
    flexDirection: "column",
    maxWidth: 160,
    width: 160,
    paddingRight: 20,
  },
  stockDataRight: {
    display: "flex",
    justifyContent: "flex-end",
  },
  stockBadge: {
    marginBottom: 5,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  stockInput: {
    marginLeft: 8,
    minWidth: "60px",
    width: 60,
  },
}));
